import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const ConsumptionEntry = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/consumption-entry/components/ConsumptionEntryContent'
      )
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default ConsumptionEntry;
